import { PageShell } from "@/components/marketing/PageShell";
import { useSiteContent } from "@/hooks/useSiteContent";

const fill = (s, c) =>
  s.replaceAll("{support}", c.support_email).replaceAll("{legal}", c.legal_email).replaceAll("{rights}", c.rights_email)
    .replaceAll("{address}", c.address || "[MAILING ADDRESS]").replaceAll("{phone}", c.phone || "[PHONE NUMBER]");

const Block = ({ b, c }) =>
  typeof b === "string" ? (
    <p className="mt-3 text-sm leading-relaxed text-oath-secondary">{fill(b, c)}</p>
  ) : (
    <ul className="mt-3 grid gap-1.5 pl-5 text-sm leading-relaxed text-oath-secondary [list-style:disc]">
      {b.list.map((li) => <li key={li}>{fill(li, c)}</li>)}
    </ul>
  );

export const LegalDoc = ({ title, effective, intro, sections, testid, before, after }) => {
  const { contact } = useSiteContent();
  return (
    <PageShell eyebrow="— LEGAL —" title={title}>
      {before}
      <div className="grid gap-6 lg:grid-cols-[240px_1fr]" data-testid={testid}>
        <nav className="hidden self-start rounded-2xl border border-gray-200 bg-white p-4 lg:sticky lg:top-28 lg:block" data-testid={`${testid}-toc`}>
          <div className="font-mono-label text-[9px] font-semibold text-oath-muted">CONTENTS</div>
          <ol className="mt-3 grid gap-1.5 text-xs">
            {sections.map((s, i) => (
              <li key={s.id}><a href={`#${s.id}`} className="text-oath-secondary hover:text-oath-accent">{i + 1}. {s.title}</a></li>
            ))}
          </ol>
        </nav>
        <article className="rounded-3xl border border-gray-200 bg-white p-6 sm:p-10">
          <div className="flex flex-wrap gap-x-6 gap-y-1 font-mono-label text-[9px] text-oath-muted">
            <span data-testid={`${testid}-effective`}>EFFECTIVE {effective}</span><span>LAST UPDATED {effective}</span>
          </div>
          <p className="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid={`${testid}-review-note`}>
            This document is provided as a comprehensive draft and is not legal advice. Have it reviewed by qualified counsel before relying on it.
          </p>
          <p className="mt-6 text-sm leading-relaxed text-oath-secondary">{fill(intro, contact)}</p>
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} className="scroll-mt-28 border-t border-gray-100 pt-6 mt-8" data-testid={`${testid}-section-${s.id}`}>
              <h2 className="font-display text-xl font-bold text-oath-ink">{i + 1}. {s.title}</h2>
              {s.body.map((b, j) => <Block key={j} b={b} c={contact} />)}
            </section>
          ))}
        </article>
      </div>
      {after && <div className="mt-6 lg:ml-[264px]">{after}</div>}
    </PageShell>
  );
};

export default LegalDoc;
